import { useEffect } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, styled } from '@mui/material';
import type { CallbackLoaderData } from 'src/app/loaders/auth_loaders';
import { notifyError } from 'src/utils';

const CallbackPageLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  height: '100vh',
  width: '100vw',
  backgroundColor: theme.palette.background.paper,
}));

const REDIRECT_DELAY_MS = 3000;

export const CallbackPage = () => {
  const data = useLoaderData() as CallbackLoaderData;
  const navigate = useNavigate();

  useEffect(() => {
    if (data.success) return;

    notifyError(data.message);
    const timer = setTimeout(() => {
      navigate('/login', { replace: true });
    }, REDIRECT_DELAY_MS);
    return () => clearTimeout(timer);
  }, [data, navigate]);

  return (
    <CallbackPageLayout>
      <CircularProgress />
      <Typography
        sx={{
          color: 'text.secondary',
        }}
      >
        {data.message}
      </Typography>
    </CallbackPageLayout>
  );
};
